const HIDE_BADGES_REGEXP = [
    /logic-test-irt\/.+\/test/,
    /auth/,
    /personality-test-irt\/.+\/test/
];

export const shouldHideBadges = (pathname: string): boolean => {
    return HIDE_BADGES_REGEXP.some(regexp => regexp.test(pathname));
};
